// The purpose of this component is to render s3 presigned urls that can be a pdf or a doc
const DocPdf = ({ resume }: { resume: string }) => {
  // If we need to render a doc we use Microsft api, else google api
  const isPdf = resume?.includes(".pdf");

  const iframe_src = isPdf
    ? resume
    : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(resume)}`;

  return (
    <div className="mt-9">
      <iframe className="w-[841px] rounded-2xl h-screen" src={iframe_src} />
    </div>
  );
};

export default DocPdf;
